module.exports = __webpack_public_path__ + "img/pexels-fauxels-3183198.65cc9145.jpg";